import * as React from "react";
import { Modal,Button,Input} from "antd";
import { connect } from "react-redux";
const { TextArea } = Input;

interface IAbnormalProps {
  id:any;
  submitTag:any;
  getOrderDetails:any;
}

// 确认函
class Abnormal extends React.Component<IAbnormalProps, any> {
  state = {
    visible:false,
    content:'',
  };
  constructor(props: IAbnormalProps) {
    super(props);
  }

  handleCancel = () => {
    this.setState({
      visible: false,
    });
  }
  
  show(id) {
    this.setState({
      visible:true
    })
  }

  onChange =(value) => {
    this.setState({
      content:value.target.value
    })     
  }
  
  onOk= () =>{
    const param: any = {
      id: this.props.id,
      type: 'unusual',
      unusualtext:this.state.content
    }; 
    this.props.submitTag({
      ...param,
      callback: (data) => {
          this.handleCancel();
          const params: any = {
            id: this.props.id
          }; 
          this.props.getOrderDetails({
            ...params,
            callback: () => {
              console.log(this.props);
            }
           });
      }
     }); 
  }
  render() {
    const buttonStyle = {
      backgroundColor: "#fff",
      color:"#000",
      border:'none',
      display: 'block',
    };
    return (
      <React.Fragment>
      <Button style={buttonStyle} onClick={this.show.bind(this,this.props.id)}>异常</Button> 
      <Modal maskClosable={false} onOk={this.onOk} onCancel={this.handleCancel} title="异常原因"  visible={this.state.visible}  width="auto" centered={true}>
          <div className="abnormal">
              <TextArea placeholder="异常原因" value={this.state.content} onChange={this.onChange}  rows={5} />
          </div>
      </Modal> 
      </React.Fragment>
    );
  }
}

const mapState = state => ({
  id: state.orderDetails.id,
});

const mapDispatch = dispatch => {
  return {
    submitTag:dispatch.orderDetails.submitTag,
    getOrderDetails: dispatch.orderDetails.getOrderDetails,
  };
};

export default connect(
  mapState ,
  mapDispatch
)(Abnormal);
